<template>
  <div id="app">
    <nav-bar></nav-bar>
    <progress-bar  v-if="loading.status" :data-message="loading.message"/>  
    <pop-notification />
    <router-view/>
		<div ref="dialogComponent" :data-id="true" v-if="showingMessage"></div>		
    <footer-component></footer-component>
  </div>
</template>
<script>
import '@/sass/global.scss'
import Vue from 'vue'
import ProgressBar from '@/components/progressBar.component'
import {mapState} from 'vuex'
import dialogComponent from '@/components/dialog.component'
import popNotification from '@/components/popNotification.component'
import navBar from '@/components/navBar.component'
import footerComponent from '@/components/footer.component'
export default {
components:{
    navBar,
    popNotification,
    footerComponent,
    ProgressBar
  },
  computed:{
    ...mapState({
      loading: state => state.loading, 
      dialog: state => state.dialog,
    })
  },
  data () {
    return {
      showingMessage: false
    }
  },
  watch: {
    'dialog.active': function (nV){
    if(nV) {
      this.showingMessage = true
      setTimeout(() => {
        this.$_messageTrigger(this.dialog.data)
      })
      }
    },
  },
  methods:{
    
	$_messageTrigger (payload)  {
		this.dialogMessages(payload)
	},
	clearActiveSnackBar (){
		this.$store.commit('SNACK_BAR_ACTION',{status: false})
	},
	dialogMessages (data) {
    let ComponentClass = Vue.extend(dialogComponent)
      let instance = new ComponentClass({
        propsData: data
      });
      let link = instance.$createElement('div', {
        attrs: {
          class: 'message'
        },
        domProps: {
          innerHTML: data.message
        }
      });
        let title = instance.$createElement('div', {
        attrs: {
          class: 'context'
        },
        domProps: {
          innerHTML: data.title
        }
      });

      instance.$slots.default = [link];
      instance.$slots.title = [title]
      instance.$mount() // pass nothing
      this.$refs.dialogComponent.appendChild(instance.$el)
    }
  }
}
</script>
<style lang="scss">
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");
@import url("https://fonts.googleapis.com/css?family=Merriweather:300,400,700");
@import url('https://fonts.googleapis.com/css2?family=Libre+Franklin:wght@300;400;500;600;700&display=swap');
#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}
.btn {
  &.rounded {
    border-radius:6px;
  }
}
.no-margin{
  margin: 0px !important;
}
.no-bottom-margin{
  margin-bottom: 0px !important;
}
.no-padding{
  padding:0px !important;
}
.no-float{
  float: none !important;
  &.center-aligned{
    margin-left: auto !important;
    margin-right: auto !important;
  }
}
.site-max {
  max-width: 1036px;
}
.clear {
  clear:both !important;
}
h1 {
  font-size:38px;
}

h2 {
  font-size:32px;
}

h3 {
  font-size:28px;
}

h4 {
  font-size:24px;
}

h5 {
  font-size:20px;
}
.new-shadow {
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02), 0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);
}
.btn.btn-medium {
  height:44px;
  line-height:44px;

  box-shadow: 0 2px 12px 0 rgba(0,0,0,.07), 0 1px 10px 0 rgba(0,0,0,.09), 0 3px 1px -2px rgba(0,0,0,.1);
  
}
.btn-floating:hover {
    background-color: #ccc;
}
button, a {
  &.btn {
    border-radius:3px;
  }
}
/* .material-tooltip {
    padding: 10px 11px !important;
  
    background-color: #7b7b7b !important;
} */
@media print {

}
</style>
